import BGLanguageMap from './product/backgammon/language-scema';
import SPLanguageMap from './product/spades/language-scema';
import RULanguageMap from './product/rummy/language-scema';
import DMLanguageMap from './product/domino/language-scema';

const schemaMap = new Map();
schemaMap.set('backgammon', BGLanguageMap);
schemaMap.set('spades', SPLanguageMap);
schemaMap.set('rummy', RULanguageMap);
schemaMap.set('domino', DMLanguageMap);

export default schemaMap;